import { render, staticRenderFns } from "./NewsTest.vue?vue&type=template&id=3a1707bf&lang=pug&"
import script from "./NewsTest.vue?vue&type=script&lang=js&"
export * from "./NewsTest.vue?vue&type=script&lang=js&"
import style0 from "./NewsTest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports